export interface IFilterPrepaymentState {
    prepaymentsFilter: number[]; // проценты предоплаты (10, 25, 50 и т.д.)
}

export interface IFilterPrepaymentMutations {
    setPrepaymentFilter: (state: IFilterPrepaymentState, value: number[]) => void;
}

const DefaultState = (): IFilterPrepaymentState => ({
    prepaymentsFilter: [],
});

export default {
    namespaced: true,
    state: DefaultState(),
    mutations: {
        setPrepaymentFilter(state: IFilterPrepaymentState, value: number[]) {
            state.prepaymentsFilter = value;
        },
    },
};

export const NAMESPACE = 'prepaymentFilterModelName';
